<zui-map-container *ngIf="reload$ | async;"
  [companyId]="companyId$ | async"
  [isZoneToggleChecked]="true"
  [isDrawToolbarShown]="isShowToolbar"
  (shapeCreatedEvent)="handleData($event)"
></zui-map-container>
